import { vendors } from "../../../data/vendors";
import Summerybox from "../../../components/Summerybox";
import PageHeading from "../../../components/PageHeading";
// import Sidebar from "../../../components/Sidebar";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import FilterTable from "../../../components/FilterTable";

const Overview = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [vendorList, setVendorList] = useState(vendors);
  const [vendorTempList, setVendorTempList] = useState([]);
  // const filteredVendors = vendors.filter((vendor) =>
  //   vendor.name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  return (
    <div>

      <div className='row pb-3'>
        <div className="flex-grow-1">
          <div className="container-fluid p-4">
            <div className='container-fluid landformconatiner p-4' style={{ maxHeight: "420px" }}>
              <div className='d-flex flex-column flex-md-row justify-content-between pe-3 ps-3 pb-3'>
                <PageHeading pagename="Vendor Overview" />
                <button className="btn btn-primary" type="button">+ Add Vendor</button>
              </div>
              <div className='expenses-conatiner' style={{ columnGap: "25px" }}>
                <Summerybox
                  color="#006CFF"
                  title="No. of Vendors"
                  number={vendors.length}
                />
                <Summerybox
                  color="#03D4C6"
                  title="Task In Progress"
                  number={vendors.reduce(
                    (sum, v) => sum + v.tasks.inProgress,
                    0
                  )}
                />
                <Summerybox
                  color="#FE996C"
                  title="Paid Amount"
                  money={vendors.reduce(
                    (sum, v) => sum + v.paidAmount,
                    0
                  )}
                />
                <Summerybox
                  color="#8B5CF6"
                  title="Remaining Amount"
                  money={vendors.reduce(
                    (sum, v) => sum + v.remainingAmount,
                    0
                  )}
                />
              </div>
            </div>

            {/* TABLE */}
            <div className="container-fluid landformconatiner p-4 mt-3">

              <div className="d-flex justify-content-between align-items-center mb-4">
                <PageHeading pagename="Vendor List" />
                <FilterTable tempList={vendorTempList} tempListMethod={setVendorTempList} originalList={vendorList} isSearch={true} isdate={false} isFilter={false} isExport={false} />

                {/* <input
                  type="text"
                  className="form-control ms-auto"
                  placeholder="Search Vendor"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ width: "300px" }}
                /> */}
              </div>

              <table className="table">
                <thead>
                  <tr className="table-head">
                    <th>Name</th>
                    <th>Paid Up Capital</th>
                    <th>Remaining Amount</th>
                    <th>Tasks Status</th>
                  </tr>
                </thead>
                <tbody>
                  {vendorList && vendorList.map((vendor) => (
                    <tr
                      key={vendor.id}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(
                          `/vendoroverview/vendordetail/${vendor.id}`
                        )
                      }
                    >
                      <td>{vendor.name}</td>
                      <td>₹ {vendor.paidAmount}</td>
                      <td>₹ {vendor.remainingAmount}</td>
                      <td>
                        <span className="text-success fw-bold">
                          {vendor.tasks.completed} ↑
                        </span>
                        <span className="text-danger fw-bold ms-3">
                          {vendor.tasks.inProgress} ↓
                        </span>
                        <span className="text-secondary fw-bold ms-3">
                          {vendor.tasks.remaining}
                        </span>
                        {/* <i
                          className="bi bi-info-circle ms-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (vendor.id) {
                              navigate(`/statustask/${vendor.id}`);
                            } else {
                              console.error("Vendor ID is undefined:", vendor);
                            }
                          }}
                        ></i> */}
                        <button className="btn p-0 m-0 align-baseline">
                          <i
                            className="bi bi-info-circle ms-3"
                            style={{ cursor: "pointer", fontSize: "1.2rem" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (vendor.id) {
                                navigate(`/statustask/${vendor.id}`);
                              } else {
                                console.error("Vendor ID is undefined:", vendor);
                              }
                            }}
                          ></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
